import request from '@/utils/httpRequest'

export default class contractService {
	// 查询合同信息详细
    getContract(contractId) {
      return request({
        url: '/mater/contract/view',
        method: 'get',
        params: {
          contractId: contractId
        },
		class:'mater'
      })
    }
	
	// 查询合同物料清单台账
	materialPurchaseTemp(contractId) {
	  return request({
	    url: '/mater/purchasetemp/material-purchase',
	    method: 'post',
	    params: {contractId: contractId},
		class:'mater'
	  })
	}
}
